<template>
  <div class="stats-grid" :style="{ '--stats-grid-columns': columns }">
    <slot />
  </div>
</template>

<script setup lang="ts">
/** A row of `StatGroup`s with a divider between neighbours; below the desktop width they go two by two */
withDefaults(defineProps<{ columns?: number }>(), { columns: 4 });
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.stats-grid {
  display: grid;
  // Auto tracks, so a group with a long label keeps it on one line and the leftover width is
  // shared out; even columns would squeeze the wordiest group and wrap only that one's labels.
  grid-template-columns: repeat(var(--stats-grid-columns), minmax(0, auto));
  // Figma: 40px between stat columns on the property dashboard
  gap: 2.5rem;

  @include screen-max-md {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--t-spacing-lg) var(--t-spacing-md);
  }
}
</style>
